import { combineReducers } from '@reduxjs/toolkit';
import { createMigrate, persistReducer } from 'redux-persist';
import type { WebStorage } from 'redux-persist/lib/types';

import { ESlice } from '@enums/redux.enum';

import authReducer from './auth/authSlice';
import { migrations } from './migrations';
import tripsReducer from './trips/tripsSlice';

// Inline localStorage engine: rolldown-vite's CJS interop breaks the default import from
// redux-persist/lib/storage (getItem/setItem come back undefined).
const storage: WebStorage = {
	getItem: (key) => Promise.resolve(localStorage.getItem(key)),
	setItem: (key, value) => Promise.resolve(localStorage.setItem(key, value)),
	removeItem: (key) => Promise.resolve(localStorage.removeItem(key)),
};

const rootReducer = combineReducers({
	[ESlice.auth]: authReducer,
	[ESlice.trips]: tripsReducer,
});

export type RootReducerState = ReturnType<typeof rootReducer>;

const persistConfig = {
	key: ESlice.root,
	storage,
	version: 1,
	migrate: createMigrate(migrations, { debug: false }),
	whitelist: [ESlice.auth, ESlice.trips],
};

export default persistReducer(persistConfig, rootReducer);
